import React, { useEffect, useRef } from "react";
import { Polyline, useMap } from "react-leaflet";
import "leaflet-polylinedecorator";
import "leaflet-geometryutil";
import L from "leaflet";

const PolylineWithText = ({ obj, positions, color, onClick, onAdded, monitoring = false, onClickViewArrow }) => {
  const map = useMap();
  const fitBoundsRef = useRef(false);
  const markerRefs = useRef([]);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (!Array.isArray(positions) || positions.length < 2) {
      return;
    }

    let polyline = null;
    if (monitoring) {
      polyline = L.polyline(positions, { color: color || "#1976D2", weight: 6 }).addTo(map);
      const bounds = L.latLngBounds(positions);
      if (!fitBoundsRef.current && bounds.isValid()) {
        map.fitBounds(bounds);
        fitBoundsRef.current = true;
      }
    }

    const latLngPositions = positions
      .map((pos) => (Array.isArray(pos) && pos.length === 2 ? L.latLng(pos[0], pos[1]) : pos instanceof L.LatLng ? pos : null))
      .filter(Boolean);

    if (latLngPositions.length < 2) return;

    const line = L.polyline(latLngPositions);
    const totalDistance = L.GeometryUtil.length(line);
    const arrowSpacing = 150;

    const decorator = L.polylineDecorator(latLngPositions, {
      patterns: [
        {
          offset: 0,
          repeat: arrowSpacing,
          symbol: L.Symbol.arrowHead({
            pixelSize: 20,
            headAngle: 60,
            polygon: true,
            pathOptions: {
              stroke: true,
              color: color || "#1976D2",
              weight: 2,
              fillOpacity: 1
            }
          })
        }
      ]
    });
    map.addLayer(decorator);
    if (onAdded) onAdded(decorator);
    markerRefs.current.forEach((m) => map.removeLayer(m));
    markerRefs.current = [];
    for (let d = arrowSpacing; d < totalDistance; d += arrowSpacing) {
      const inter = L.GeometryUtil.interpolateOnLine(
        map,
        line,
        d / totalDistance
      );

      if (!inter || !inter.latLng) continue;

      const marker = L.marker(inter.latLng, {
        icon: L.divIcon({
          className: "clickable-marker",
          html: `
            <div style="width:20px; height:20px;">
            </div>
          `,
          iconSize: [20, 20],
          iconAnchor: [10, 10]
        }),
        interactive: true
      }).addTo(map);

      marker.on("click", (e) => {
        if (onClickViewArrow) onClickViewArrow(obj, e);
      });
      markerRefs.current.push(marker);
    }
    return () => {
      if (polyline && monitoring) {
        map.removeLayer(polyline);
      }
      if (decorator) {
        map.removeLayer(decorator);
      }
      markerRefs.current.forEach((marker) => map.removeLayer(marker));
      markerRefs.current = [];
    };
  }, [map, positions, color, onClick, onAdded, monitoring, onClickViewArrow]);

  return !monitoring ? (
    <Polyline
      positions={positions}
      color={color}
      weight={6}
      eventHandlers={{
        add: (e) => {
          if (onAdded) onAdded(e);
        },
        click: (e) => {
          if (onClick) onClick(e);
        },
      }}
    />
  ) : null;
};

export default PolylineWithText;
